import { module as BaseModule } from 'modujs'

export default class extends BaseModule {
  init() {
    this.label = this.el.querySelector('label')
    this.inputs = this.el.querySelectorAll('input, textarea')

    if (this.inputs.length > 0) {
      this.input = this.inputs[0] // eslint-disable-line
    } else {
      return
    }

    this.fieldset = this.el.querySelector('[data-field-radio-inputs]')
    if (this.fieldset) {
      this.initFieldset()
      return
    }

    this.el.addEventListener('click', () => {
      this.label.classList.add('opacity-0')
      this.input.style.opacity = 1
      this.input.focus()
    })

    this.input.addEventListener('focus', () => {
      this.label.classList.add('opacity-0')
      this.input.style.opacity = 1
    })

    this.input.addEventListener('blur', () => {
      if (this.input.value === '') {
        this.el.classList.add('invalid-field')
        this.label.classList.remove('opacity-0')
        this.input.removeAttribute('style')
      }
    })
  }

  initFieldset() {
    const buttons = this.fieldset.querySelectorAll('button')
    this.label.addEventListener('click', () => {
      this.fieldset.style.display = 'grid'
      this.fieldset.style.opacity = 1
      this.fieldset.style.pointerEvents = 'all'
    })

    buttons.forEach((button, index) => {
      const { buttonOption } = button.dataset

      button.addEventListener('click', (e) => {
        e.preventDefault()

        this.label.innerHTML = button.innerHTML
        this.label.style.backgroundColor = 'white'
        this.label.classList.add('shadow-default')
        this.fieldset.removeAttribute('style')
        this.input.value = buttonOption

        const event = new Event('change')
        this.input.dispatchEvent(event)

        buttons.forEach((btn, i) => {
          if (i === index) {
            btn.classList.add('is-checked')
            btn.setAttribute('aria-selected', 'true')
          } else {
            btn.classList.remove('is-checked')
            btn.removeAttribute('aria-selected')
          }
        })
      })
    })
  }
}
